const initSwfLessonsAccionata = () => {
    const temario = document.querySelector(".clases-temario-modulo__bloque-lecciones");
    const bloqueClase = document.querySelectorAll(".bloque-clase-leccion");
    
    if (!temario) return;

    let examenes;
    if (temario.classList.contains("accionate")) {
        examenes = [2494, 2499, 2502, 9325];
    } else {
        examenes = [18195, 18142, 18209, 18212];
    }

    console.log(examenes);

    bloqueClase.forEach(clase => {
        const id = parseInt(clase.getAttribute("data-id"));
        if (examenes.includes(id)) {
            clase.remove();
        }
    });
}

export default initSwfLessonsAccionata;